import * as React from "react";
import * as recordService from "../../../models/services/recordService";
import { Dialog } from "../../framework/Dialog/Dialog";
import { Translations } from "ui/Scripts/source/models/translations";
import { List } from "../../framework/List/List";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { RecordExpiredFamiliarizationsList } from "../RecordExpiredFamiliarizationsList";

export interface IRecordArchiveExpiredFamiliarizationsDialogProps {
    classes?: string;
    companyId: string;
    onOk: () => void;
    onCancel: () => void;
}

export interface IRecordArchiveExpiredFamiliarizationsDialogState {
    selectedId: string;
    checkedIds: string[];
}

export class RecordArchiveExpiredFamiliarizationsDialog extends React.Component<IRecordArchiveExpiredFamiliarizationsDialogProps, IRecordArchiveExpiredFamiliarizationsDialogState> {
    constructor(props: IRecordArchiveExpiredFamiliarizationsDialogProps) {
        super(props);
        this.state = {
            selectedId: null,
            checkedIds: [],
        };
    }

    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.setState({
            selectedId,
            checkedIds
        });
    };

    handleCancel = () => {
        this.props.onCancel();
    };

    static getSaveData = (companyId: string, recordUserFamiliarizationsIds: string[]): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("ids", recordUserFamiliarizationsIds);
        result.append("companyId", companyId);
        return result;
    };

    static archiveRecordUserFamiliarizations = async (companyId: string, recordUserFamiliarizationsIds: string[]): Promise<SaveSuccess> => {
        if (recordUserFamiliarizationsIds.length < 1) return;
        const saveData = RecordArchiveExpiredFamiliarizationsDialog.getSaveData(companyId, recordUserFamiliarizationsIds);
        // Call server
        return await AppUtils.callService(() => recordService.archiveRecordUserFamiliarizations(saveData.obj));
    };

    handleOk = async () => {
        const state = this.state;
        const result = await RecordArchiveExpiredFamiliarizationsDialog.archiveRecordUserFamiliarizations(this.props.companyId, List.getSelectedIds(state.selectedId, state.checkedIds));
        if (!result) return null;
        this.props.onOk();
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="record-archive-expired-familiarization-dialog"
                maxWidth="lg"
                maxHeight="90%"
                title={Translations.ArchiveExpiredFamiliarizations}
                body={
                    <RecordExpiredFamiliarizationsList
                        companyId={props.companyId}
                        isReport={false}
                        employeeTypes={[]}
                        jobTitles={[]}
                        unitIds={[]}
                        activityState={0}
                        selectedId={state.selectedId}
                        checkedIds={state.checkedIds}
                        onSetSelectedIds={this.handleSetSelectedIds}
                    />
                }
                buttons={[
                    { title: Translations.Close, variant: "outlined", onClick: this.handleCancel },
                    { title: Translations.Archive, variant: "confirmation", onClick: this.handleOk },
                ]}
                onClose={this.handleCancel}
            />
        );
    }
}